<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 13.65">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <path class="cls-1" fill="#a5d867" d="M0,13.65V0H7V13.54l-3.44-3.2L0,13.65Z"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
  name: 'BookMarkGrn'
}
</script>

<style scoped>
    svg {
        width: 7px;
        height: 13.65px;
    }
</style>